<template>
    <form @change="sendDataForSaving">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">English proficiency?</label>
                    <div class="form-group form-group-1">
                        <div>
                            <VueMultiSelect
                                class="custom-select select-multiple"
                                allow-empty="required" multiple="multiple"
                                :options="skills"
                                :selected_options="form.english_proficiency"
                                v-model="form.english_proficiency"
                            ></VueMultiSelect>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dashed-border-block">

            <ForeignLanguageInput
                v-for="(language, index) in form.languages"
                :language.sync="language"
                :languages-list="languagesList"
                :key="index"
            ></ForeignLanguageInput>

            <div class="add-row text-right">
                <button
                    class="add-link"
                    @click.prevent="addLanguage"
                >
                    + Add Foreign language
                </button>
            </div>
        </div>
        <div class="center-separated-block">
            <div class="half-block">
                <h6>Restrictions</h6>
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Are you ok working outdoors?</label>
                    <div class="buttons-type-multiselect two-btns">

                        <ValidationProvider
                            name="Working outdoors"
                            rules="required"
                            v-slot="{ errors }"
                            class="item"
                        >
                            <input
                                type="radio"
                                name="name21"
                                class="rad"
                                id="id-212"
                                value="1"
                                v-model="form.working_outdoors"
                            >
                            <label for="id-212">
                                <div class="ttl">Yes</div>
                            </label>
                            <FormError :error="errors[0]" name="Working outdoors"></FormError>
                        </ValidationProvider>

                        <div class="item">
                            <input
                                type="radio"
                                name="name21"
                                class="rad"
                                id="id-213"
                                value="0"
                                v-model="form.working_outdoors"
                            >
                            <label for="id-213">
                                <span class="ttl">No</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Are you ok working on Sundays?</label>
                    <div class="buttons-type-multiselect two-btns">

                        <ValidationProvider
                            name="Working on Sundays"
                            rules="required"
                            v-slot="{ errors }"
                            class="item"
                        >
                            <input
                                type="radio"
                                name="name15"
                                class="rad"
                                id="id-512"
                                value="1"
                                v-model="form.working_sundays"
                            >
                            <label for="id-512">
                                <div class="ttl">Yes</div>
                            </label>
                            <FormError :error="errors[0]" name="Working on Sundays"></FormError>
                        </ValidationProvider>

                        <div class="item">
                            <input
                                type="radio"
                                name="name15"
                                class="rad"
                                id="id-513"
                                value="0"
                                v-model="form.working_sundays"
                            >
                            <label for="id-513">
                                <span class="ttl">No</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-group form-group-1">
                    <label
                        for=""
                        class="form-label"
                    >
                        Are you ok walking for long periods of time if
                        necessary?
                    </label>
                    <div class="buttons-type-multiselect two-btns">

                        <ValidationProvider
                            name="Are you ok walking for long periods of time"
                            rules="required"
                            v-slot="{ errors }"
                            class="item"
                        >
                            <input
                                type="radio"
                                name="name771"
                                class="rad"
                                id="id-712"
                                value="1"
                                v-model="form.walking_long"
                            >
                            <label for="id-712">
                                <div class="ttl">Yes</div>
                            </label>
                            <FormError :error="errors[0]" name="Are you ok walking for long periods of time"></FormError>
                        </ValidationProvider>

                        <div class="item">
                            <input
                                type="radio"
                                name="name771"
                                class="rad"
                                id="id-713"
                                value="0"
                                v-model="form.walking_long"
                            >
                            <label for="id-713">
                                <span class="ttl">No</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="half-block">
                <h6>Transportation</h6>
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Transportation to work every day?</label>
                    <div class="buttons-type-multiselect two-btns">

                        <ValidationProvider
                            name="Transportation to work every day?"
                            rules="required"
                            v-slot="{ errors }"
                            class="item"
                        >
                            <input
                                type="radio"
                                name="name451"
                                class="rad"
                                id="id-4512"
                                value="1"
                                v-model="form.transportation"
                            >
                            <label for="id-4512">
                                <div class="ttl">Yes</div>
                            </label>
                            <FormError :error="errors[0]"  name="Transportation to work every day?"></FormError>
                        </ValidationProvider>

                        <div class="item">
                            <input
                                type="radio"
                                name="name451"
                                class="rad"
                                id="id-4513"
                                value="0"
                                v-model="form.transportation"
                            >
                            <label for="id-4513">
                                <span class="ttl">No</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap-border-top">
            <div class="row">
                <div class="col-12">
                    <label for="" class="form-label">Do you agree to be photographed during your employment(for both
                        cards and ORNA promotional products and marketing)</label>
                </div>
                <div class="col-md-6">
                    <div class="form-group form-group-1">
                        <div class="buttons-type-multiselect two-btns">

                            <ValidationProvider
                                name="Do you agree to be photographed?"
                                rules="required"
                                v-slot="{ errors }"
                                class="item">
                                <input
                                    type="radio"
                                    name="name22"
                                    class="rad"
                                    id="id-1132"
                                    value="1"
                                    v-model="form.be_photographed"
                                >
                                <label for="id-1132">
                                    <div class="ttl">Yes</div>
                                </label>
                                <FormError :error="errors[0]"  name="Do you agree to be photographed?"></FormError>
                            </ValidationProvider>

                            <div class="item">
                                <input
                                    type="radio"
                                    name="name22"
                                    class="rad"
                                    id="id-1212"
                                    value="0"
                                    v-model="form.be_photographed"
                                >
                                <label for="id-1212">
                                    <span class="ttl">No</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

</template>

<script>

import ForeignLanguageInput from "./ForeignLanguageInput.vue";
import EnglishProficiency from "../../../../../../resources/js/mixins/EnglishProficiency";
import VueMultiSelect from "../../../../../../resources/js/plugins/VueMultiSelect.vue";

export default {
    name: 'QualificationsForm',
    components: {
        VueMultiSelect,
        ForeignLanguageInput
    },
    mixins: [
        EnglishProficiency,
    ],
    props: {
        languagesList: {
            type: Array,
            required: true
        },
        user: {
            type: Object
        },
        isMasterAdmin: Boolean
    },
    data() {
        return {
            form: {
                english_proficiency: [],
                languages:  [],
                working_outdoors: null,
                working_sundays: null,
                walking_long: null,
                transportation: null,
                be_photographed: null
            },
        }
    },
    methods: {
        addLanguage() {
            this.form.languages.push({
                id: null,
                other: null,
                speak: null,
            })
        },
        sendDataForSaving() {
            this.$emit('data-changed', this.form);
        },
        setData() {
            for (const userKey in this.user.qualification) {
                for (const formKey in this.form) {
                    if (userKey === formKey) {
                        this.form[userKey] = this.user.qualification[formKey];
                    }
                }
            }
        },
    },
    mounted() {
        if (this.user.qualification !== null){
            this.form.english_proficiency = this.user.qualification.english_proficiency
            this.setData()

            const restructuredArray = this.user.qualification.languages.map(item => ({
                id: item.language_id,
                speak: item.speak,
                other: item.other
            }));

            if (this.user.qualification.languages.length > 0) {
                this.form.languages = restructuredArray;
            }
        }

    },
    updated() {
        this.sendDataForSaving()
    },
}
</script>

<style scoped>

</style>
